export default __webpack_public_path__ + "a5ca2858b7fc70683387ad6a2bb75416.png";